// src/features/programme-create/routes.js
export default [
  {
    path: "/programmes/create/",
    name: "create-project",
    component: () => import("@/features/programme-create/pages/ProgrammeCreatePage.vue"),
    meta: {
      layout: "app",
      group: "Projects",
      title: "Create Programme",
      breadcrumbs: [
        { name: "Programmes", route: "project-list" },
        { name: "Create Programme", route: "create-project" },
      ],
    },
  },

  // Legacy redirect
  {
    path: "/programmes/create-project/:id?/",
    redirect: () => ({ name: "create-project" }),
  },
];